import { DEFAULT_SOCIAL_WALLET_IMAGE, PRIVY_COMPATIBLE_SOCIAL_NETWORK, SOCIAL_WALLET_IMAGE_BY_SOCIAL_NETWORKS, } from './ConnectWalletModal.constants';
export function getSocialWalletImage(user) {
    for (const network of PRIVY_COMPATIBLE_SOCIAL_NETWORK) {
        if (user?.[network]) {
            return SOCIAL_WALLET_IMAGE_BY_SOCIAL_NETWORKS[network];
        }
    }
    return DEFAULT_SOCIAL_WALLET_IMAGE;
}
